<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-3"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-form ref="form">
          <v-card
            class="mx-auto justify-center mb-1 mt-3"
            max-width="95%"
            :class="{'pa-6': !isMobile}"
            style="border-radius: 10px"
            :elevation="(isMobile ? 0 : 10)"
            :flat="isMobile"
          >
            <v-row :class="{'mx-0' : !isMobile}">
              <v-card-title
                class="justify-start mt-4"
                :style="{'margin-top':(isMobile ? '40px !important' : '0px')}"
                grey
                style="width: 100%"
                darken-3
              >
                <h2>{{ $t('chooseYourPlan') }}</h2>
              </v-card-title>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <pricing
                  v-model="plan"
                  :get-plan="true"
                />
              </v-col>
              <v-col
                class="py-0"
                style="display: flex"
                cols="12"
                md="12"
                sm="12"
              >
                <div
                  class="mx-auto justify-center primary--text mt-2"
                  style="cursor: pointer;font-size: 14px"
                  @click="editEmail"
                >
                  {{ $t('editPhone') }}
                </div>
              </v-col>
              <v-col cols="12" />
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Language from '../../components/core/LanguageBar'
  // import plans from '../../../../plan.json'
  import pricing from '../General/pricing.vue'
  export default {
    components: {
      Language,
      pricing,
    },
    mixins: [General],
    props: ['emailProp', 'phoneProp', 'phonePrefixProp', 'planProp'],
    data () {
      return {
        snakbar: false,
        snakbarColor: null,
        email: null,
        currency: null,
        phonePrefix: null,
        phone: null,
        abrName: null,
        dateFormat: 'fa,en',
        dateFormatLang: 'YYYY/MM/DD',
        yearName: null,
        plan: null,
        from: null,
        to: null,
        show: null,
        code: null,
        lang: null,
        firstname: null,
        lastname: null,
        username: null,
        password: null,
        has_error: false,
        text_error: null,
        snakbarText: null,
        loading: false,
      }
    },
    watch: {
      plan (val) {
        if (val) {
          this.submit(val)
        }
      },
      dateFormat () {
        this.from = null
        this.to = null
        if (this.dateFormat === 'fa,en') {
          this.dateFormatLang = 'jYYYY/jMM/jDD'
        }
        if (this.dateFormat === 'en,fa') {
          this.dateFormatLang = 'YYYY/MM/DD'
        }
      },
    },
    beforeMount () {
      // this.plan = plans
      if (!this.phoneProp) {
        this.goTo('register')
      }
      if (this.planProp) {
        this.submit(this.planProp)
      }
      this.phonePrefix = this.phonePrefixProp
      this.phone = this.phoneProp
      if (this.dateFormat === 'fa,en') {
        this.dateFormatLang = 'jYYYY/jMM/jDD'
      }
      if (this.dateFormat === 'en,fa') {
        this.dateFormatLang = 'YYYY/MM/DD'
      }
    },
    mounted () {
      if (localStorage.getItem('lang')) {
        this.$refs.refLang.changeLanguage(JSON.parse(localStorage.getItem('lang')))
      }
    },
    methods: {
      submit (plan) {
        this.$router.push({ name: 'registerInitial', params: { emailProp: this.emailProp, planProp: plan, phoneProp: this.phoneProp } })
        // if (!plan) {
        //   this.snakbarText = this.$t('pleaseChooseYourPlan')
        //   this.snakbarColor = 'pink'
        //   this.snakbar = true
        // } else {
        // }
      },
      editEmail () {
        this.goTo('register')
      },
    },

  }
</script>

<style scoped>

</style>
